module.exports = __webpack_public_path__ + "components/country-flag/static/mm-2b2a394fb01d4515aeee11a51e9b3822.svg";